const RFC_PERSONA_FISICA = /^[A-ZÑ&]{4}\d{6}[A-Z\d]{3}$/;
const RFC_PERSONA_MORAL = /^[A-ZÑ&]{3}\d{6}[A-Z\d]{3}$/;

/**
 * Valida el formato de un RFC según el tipo de persona.
 * @param {string} rfc - El RFC a validar
 * @param {string} tipoPersona - 'fisica' o 'moral'
 * @returns {{ valido: boolean, error: string }}
 */
export function validarFormatoRFC(rfc, tipoPersona) {
  if (!rfc || typeof rfc !== 'string') {
    return { valido: false, error: 'Formato de RFC inválido' };
  }

  const rfcUpper = rfc.toUpperCase();
  const patron = tipoPersona === 'fisica' ? RFC_PERSONA_FISICA : RFC_PERSONA_MORAL;
  const valido = patron.test(rfcUpper);

  return {
    valido,
    error: valido ? '' : 'Formato de RFC inválido'
  };
}

export { RFC_PERSONA_FISICA, RFC_PERSONA_MORAL };

export default validarFormatoRFC;
